interface SectionContent {
  tag?: string;
  title: string;
  content: string;
  image?: string;
}

export default  class NonprofitLocale {
  public title: string = "";
  public description: string = "";

  public content: Array<SectionContent> = [];
  constructor() {
    const { locale } = useI18n();
    const header = headerLocal.find((item) => item.locale == locale.value);
    this.title = header?.title ?? headerLocal[0].title;
    this.description = header?.description ?? headerLocal[0].description;
    const content = contentLocal.find((item) => item.locale == locale.value);
    this.content = content?.data ?? contentLocal[0].data;
  }
}

const headerLocal: Array<{
  locale: string;
  title: string;
  description: string;
}> = [
  {
    locale: "en",
    title: "QR Codes for <span class='text-success'>Nonprofits</span>",
    description:
      "QR Codes are known for their heavy use in e-commerce and packaging. However, they can also be used as an ideal marketing tool by non-profit organizations that have already started using them.",
  },
  {
    locale: "vi",
    title: "Mã QR cho <span class='text-success'>Tổ chức Phi lợi nhuận</span>",
    description:
      "Mã QR được biết đến với việc sử dụng nhiều trong thương mại điện tử và đóng gói. Tuy nhiên, chúng cũng có thể được sử dụng như một công cụ marketing lý tưởng bởi các tổ chức phi lợi nhuận đã bắt đầu sử dụng chúng.",
  },
  {
    locale: "de",
    title:
      "QR-Codes für <span class='text-success'>Nonprofit-Organisationen</span>",
    description:
      "QR-Codes sind bekannt für ihre häufige Verwendung im E-Commerce und bei Verpackungen. Sie können jedoch auch als ideales Marketing-Tool von Nonprofit-Organisationen genutzt werden, die sie bereits einsetzen.",
  },
  {
    locale: "fr",
    title:
      "Codes QR pour les <span class='text-success'>organisations à but non lucratif</span>",
    description:
      "Les codes QR sont connus pour leur utilisation intensive dans le commerce électronique et l'emballage. Cependant, ils peuvent également être utilisés comme outil de marketing idéal par les organisations à but non lucratif qui les utilisent déjà.",
  },
  {
    locale: "es",
    title:
      "Códigos QR para <span class='text-success'>Organizaciones sin fines de lucro</span>",
    description:
      "Los códigos QR son conocidos por su amplio uso en el comercio electrónico y en el embalaje. Sin embargo, también pueden ser utilizados como una herramienta de marketing ideal por organizaciones sin fines de lucro que ya los están utilizando.",
  },
  {
    locale: "it",
    title:
      "Codici QR per le <span class='text-success'>Organizzazioni non profit</span>",
    description:
      "I codici QR sono noti per il loro ampio utilizzo nel commercio elettronico e nell'imballaggio. Tuttavia, possono anche essere utilizzati come strumento di marketing ideale dalle organizzazioni non profit che li utilizzano già.",
  },
  {
    locale: "pt",
    title:
      "Códigos QR para <span class='text-success'>Organizações sem fins lucrativos</span>",
    description:
      "Os códigos QR são conhecidos por seu amplo uso no comércio eletrônico e embalagem. No entanto, também podem ser usados como uma ferramenta de marketing ideal pelas organizações sem fins lucrativos que já os estão usando.",
  },
  {
    locale: "nl",
    title:
      "QR-codes voor <span class='text-success'>non-profitorganisaties</span>",
    description:
      "QR-codes staan bekend om hun veelvuldige gebruik in e-commerce en verpakkingen. Ze kunnen echter ook worden gebruikt als een ideaal marketinginstrument door non-profitorganisaties die ze al gebruiken.",
  },
  {
    locale: "ja",
    title: "<span class='text-success'>非営利団体</span>のためのQRコード",
    description:
      "QRコードは、電子商取引や包装での広範な利用が知られています。しかしながら、それらはすでに利用している非営利団体にとって理想的なマーケティングツールとしても使われることがあります。",
  },
  {
    locale: "zh",
    title: "非营利组织的二维码",
    description:
      "QR码以其在电子商务和包装中的广泛使用而闻名。然而，已经开始使用它们的非营利组织也可以将其用作理想的营销工具。",
  },
];

const contentLocal: Array<{
  locale: string;
  data: Array<SectionContent>;
}> = [
  {
    locale: "en",
    data: [
      {
        image: "/nonprofit/scan.png",
        tag: "Donations",
        title: "Promote your organization's donation page",
        content:
          "A nonprofit can place a QR code on a donation box, on a poster, on the door of a friendly coffee shop, or at the store's checkout to invite people to contribute to a campaign",
      },

      {
        image: "/nonprofit/social.png",
        tag: "Socials Media",
        title: "Nonprofits on Social Media",
        content:
          "<p>The power of social media can be challenging to put into words, but it is an integral part of the fundraising strategy for a modern nonprofit.</p><p>A successful social media presence can not only help you expand your reach and boost your community of supporters - it even has a direct correlation with the amount raised.</p>",
      },

      {
        image: "/nonprofit/feedback.png",
        tag: "Strengthen",
        title: "Improve the quality of the organization",
        content:
          "<p>What makes a non-profit organization successful is the satisfaction and trust of its people. By incorporating the QRGateway Feedback QR Code, you can quickly request participants' feedback.</p><p>We will email reviews to your organization. Now you can quickly modify and improve your organization's employees, volunteers, and members.</p>",
      },
      {
        image: "/nonprofit/donate.png",
        tag: "Event",
        title: "Event announcement of the organization",
        content:
          "<p>Any nonprofit can use Event QR codes to share event details, locations, or even event reminders.</p><p>In promotional materials for an upcoming event, a nonprofit can add a Nonprofit QR code that requires a smartphone to scan to save event details embedded in the default calendar app. This helps to remind the event to potential supporters.</p><p>Google Map QR Code can even display the event's location on Google Maps so that attendees don't have to have a hard time locating the venue.</p>",
      },
    ],
  },
  {
    locale: "zh",
    data: [
      {
        image: "/nonprofit/scan.png",
        tag: "捐赠",
        title: "宣传您的组织的捐赠页面",
        content:
          "非营利组织可以将二维码放置在捐赠箱上、海报上、友好咖啡店的门上，或者在商店的收银台上，邀请人们参与一项活动。",
      },

      {
        image: "/nonprofit/social.png",
        tag: "社交媒体",
        title: "非营利组织在社交媒体上的存在",
        content:
          "<p>社交媒体的力量难以言喻，但对于现代非营利组织的筹款策略来说，它是一个不可或缺的部分。</p><p>成功的社交媒体存在不仅可以帮助您扩大影响范围、提高支持者的数量，甚至还与筹集的金额直接相关。</p>",
      },
      {
        image: "/nonprofit/feedback.png",
        tag: "加强",
        title: "提高组织的质量",
        content:
          "<p>使非营利组织成功的是其人民的满意度和信任度。通过使用QRGateway反馈二维码，您可以快速请求参与者的反馈。</p><p>我们将通过电子邮件向您的组织发送评论。现在，您可以快速修改和改善您的组织员工、志愿者和成员。</p>",
      },
      {
        image: "/nonprofit/donate.png",
        tag: "活动",
        title: "组织的活动公告",
        content:
          "<p>任何非营利组织都可以使用活动二维码分享活动详情、地点甚至活动提醒。</p><p>在即将到来的活动的宣传材料中，非营利组织可以添加一个非营利组织二维码，需要使用智能手机扫描以保存嵌入默认日历应用程序中的活动详情。这有助于提醒潜在的支持者参加活动。</p><p>Google地图二维码甚至可以在Google地图上显示活动的位置，这样参与者就不必费力地寻找场地了。</p>",
      },
    ],
  },
  {
    locale: "vi",
    data: [
      {
        image: "/nonprofit/scan.png",
        tag: "Đóng góp",
        title: "Quảng bá trang web đóng góp của tổ chức của bạn",
        content:
          "Một tổ chức phi lợi nhuận có thể đặt mã QR trên hộp đóng góp, trên poster, trên cửa hàng cà phê thân thiện hoặc ở quầy thanh toán của cửa hàng để mời mọi người đóng góp cho chiến dịch.",
      },
      {
        image: "/nonprofit/social.png",
        tag: "Mạng xã hội",
        title: "Tổ chức phi lợi nhuận trên mạng xã hội",
        content:
          "<p>Sức mạnh của mạng xã hội có thể là thách thức để diễn tả bằng lời, nhưng nó là một phần không thể thiếu trong chiến lược gây quỹ cho tổ chức phi lợi nhuận hiện đại.</p><p>Một tài khoản mạng xã hội thành công không chỉ giúp bạn mở rộng phạm vi và tăng cộng đồng nhà tài trợ của mình - nó còn có một mối liên hệ trực tiếp với số tiền được gây quỹ.</p>",
      },

      {
        image: "/nonprofit/feedback.png",
        tag: "Tăng cường",
        title: "Nâng cao chất lượng tổ chức",
        content:
          "<p>Điều làm cho một tổ chức phi lợi nhuận thành công là sự hài lòng và tin tưởng của người dân. Bằng cách tích hợp mã QR Feedback của QRGateway, bạn có thể nhanh chóng yêu cầu ý kiến phản hồi từ người tham gia.</p><p>Chúng tôi sẽ gửi đánh giá qua email đến tổ chức của bạn. Bây giờ, bạn có thể nhanh chóng sửa đổi và cải thiện nhân viên, tình nguyện viên và thành viên của tổ chức của mình.</p>",
      },
      {
        image: "/nonprofit/donate.png",
        tag: "Sự kiện",
        title: "Thông báo sự kiện của tổ chức",
        content:
          "<p>Bất kỳ tổ chức phi lợi nhuận nào cũng có thể sử dụng mã QR Sự kiện để chia sẻ thông tin về sự kiện, địa điểm hoặc thậm chí là nhắc nhở về sự kiện.</p><p>Trong tài liệu quảng cáo cho sự kiện sắp tới, một tổ chức phi lợi nhuận có thể thêm mã QR phi lợi nhuận yêu cầu quét bằng điện thoại thông minh để lưu thông tin chi tiết về sự kiện được nhúng trong ứng dụng lịch mặc định. Điều này giúp nhắc nhở về sự kiện cho những người ủng hộ tiềm năng.</p><p>Mã QR Google Map thậm chí còn có thể hiển thị vị trí sự kiện trên Google Maps để giúp người tham dự không gặp khó khăn trong việc tìm địa điểm.</p>",
      },
    ],
  },
  {
    locale: "de",
    data: [
      {
        image: "/nonprofit/scan.png",
        tag: "Spenden",
        title: "Fördern Sie die Spenden-Seite Ihrer Organisation",
        content:
          "Eine gemeinnützige Organisation kann einen QR-Code auf einen Spendenkasten, auf ein Poster, auf die Tür eines freundlichen Cafés oder an der Kasse eines Geschäfts setzen, um Menschen zur Unterstützung einer Kampagne einzuladen.",
      },
      {
        image: "/nonprofit/social.png",
        tag: "Soziale Medien",
        title: "Gemeinnützige Organisationen in den sozialen Medien",
        content:
          "<p>Die Macht der sozialen Medien kann schwer in Worte zu fassen sein, aber sie ist ein integraler Bestandteil der Fundraising-Strategie einer modernen gemeinnützigen Organisation.</p><p>Eine erfolgreiche Präsenz in den sozialen Medien kann nicht nur dazu beitragen, Ihre Reichweite zu erweitern und Ihre Gemeinschaft von Unterstützern zu stärken - sie korreliert sogar direkt mit der gesammelten Summe.</p>",
      },

      {
        image: "/nonprofit/feedback.png",
        tag: "Stärken",
        title: "Verbessern Sie die Qualität Ihrer Organisation",
        content:
          "<p>Was eine gemeinnützige Organisation erfolgreich macht, ist die Zufriedenheit und das Vertrauen ihrer Menschen. Durch die Integration des QRGateway Feedback-QR-Codes können Sie schnell Feedback von Teilnehmern einholen.</p><p>Wir senden Ihnen Bewertungen per E-Mail zu. So können Sie schnell Mitarbeiter, Freiwillige und Mitglieder Ihrer Organisation anpassen und verbessern.</p>",
      },
      {
        image: "/nonprofit/donate.png",
        tag: "Veranstaltung",
        title: "Ankündigung einer Veranstaltung der Organisation",
        content:
          "<p>Jede gemeinnützige Organisation kann Event-QR-Codes nutzen, um Veranstaltungsdetails, -orte oder sogar Veranstaltungserinnerungen zu teilen.</p><p>In Werbematerialien für eine anstehende Veranstaltung kann eine gemeinnützige Organisation einen Nonprofit-QR-Code hinzufügen, der von einem Smartphone gescannt werden muss, um Veranstaltungsdetails in der Standardkalender-App zu speichern. Dies hilft potenziellen Unterstützern, sich an die Veranstaltung zu erinnern.</p><p>Google Maps QR-Code kann sogar den Veranstaltungsort auf Google Maps anzeigen, damit Teilnehmer keine Schwierigkeiten haben, den Veranstaltungsort zu finden.</p>",
      },
    ],
  },
  {
    locale: "es",
    data: [
      {
        image: "/nonprofit/scan.png",
        tag: "Donaciones",
        title: "Promocione la página de donaciones de su organización",
        content:
          "Una organización sin fines de lucro puede colocar un código QR en una caja de donaciones, en un cartel, en la puerta de una cafetería amigable o en el momento del pago en la tienda para invitar a las personas a contribuir a una campaña",
      },
      {
        image: "/nonprofit/social.png",
        tag: "Redes sociales",
        title: "Organizaciones sin fines de lucro en las redes sociales",
        content:
          "<p>El poder de las redes sociales puede ser difícil de expresar con palabras, pero es una parte integral de la estrategia de recaudación de fondos para una organización sin fines de lucro moderna.</p><p>Una presencia exitosa en las redes sociales no solo puede ayudarlo a expandir su alcance y aumentar su comunidad de seguidores, sino que incluso tiene una correlación directa con la cantidad recaudada.</p>",
      },

      {
        image: "/nonprofit/feedback.png",
        tag: "Fortalecer",
        title: "Mejore la calidad de la organización",
        content:
          "<p>Lo que hace que una organización sin fines de lucro tenga éxito es la satisfacción y confianza de su gente. Al incorporar el código QR de comentarios de QRGateway, puede solicitar rápidamente la retroalimentación de los participantes.</p><p>Enviaremos reseñas por correo electrónico a su organización. Ahora puede modificar y mejorar rápidamente a los empleados, voluntarios y miembros de su organización.</p>",
      },
      {
        image: "/nonprofit/donate.png",
        tag: "Evento",
        title: "Anuncio de eventos de la organización",
        content:
          "<p>Cualquier organización sin fines de lucro puede utilizar códigos QR de eventos para compartir detalles del evento, ubicaciones o incluso recordatorios del evento.</p><p>En los materiales promocionales para un evento próximo, una organización sin fines de lucro puede agregar un código QR sin fines de lucro que requiere que un teléfono inteligente lo escanee para guardar los detalles del evento incrustados en la aplicación de calendario predeterminada. Esto ayuda a recordar el evento a posibles seguidores.</p><p>El código QR de Google Maps incluso puede mostrar la ubicación del evento en Google Maps para que los asistentes no tengan problemas para encontrar el lugar.</p>",
      },
    ],
  },
  {
    locale: "fr",
    data: [
      {
        image: "/nonprofit/scan.png",
        tag: "Dons",
        title: "Promouvoir la page de dons de votre organisation",
        content:
          "Une organisation à but non lucratif peut placer un code QR sur une boîte de dons, sur une affiche, sur la porte d'un café sympathique, ou lors du passage en caisse pour inviter les gens à contribuer à une campagne.",
      },
      {
        image: "/nonprofit/social.png",
        tag: "Réseaux sociaux",
        title: "Les organisations à but non lucratif sur les réseaux sociaux",
        content:
          "<p>Le pouvoir des réseaux sociaux peut être difficile à exprimer en mots, mais il fait partie intégrante de la stratégie de collecte de fonds pour une organisation à but non lucratif moderne.</p><p>Une présence réussie sur les réseaux sociaux peut non seulement vous aider à étendre votre portée et à renforcer votre communauté de supporters, mais elle est également directement corrélée au montant collecté.</p>",
      },

      {
        image: "/nonprofit/feedback.png",
        tag: "Renforcer",
        title: "Améliorer la qualité de l'organisation",
        content:
          "<p>La satisfaction et la confiance de ses membres sont ce qui rend une organisation à but non lucratif réussie. En incorporant le code QR de commentaires de QRGateway, vous pouvez rapidement demander les commentaires des participants.</p><p>Nous enverrons les avis par e-mail à votre organisation. Vous pouvez maintenant modifier et améliorer rapidement les employés, les bénévoles et les membres de votre organisation.</p>",
      },
      {
        image: "/nonprofit/donate.png",
        tag: "Événement",
        title: "Annonce d'événement de l'organisation",
        content:
          "<p>Toute organisation à but non lucratif peut utiliser des codes QR d'événements pour partager des détails d'événements, des lieux ou même des rappels d'événements.</p><p>Dans les supports promotionnels pour un événement à venir, une organisation à but non lucratif peut ajouter un code QR sans but lucratif qui nécessite qu'un smartphone le scanne pour enregistrer les détails de l'événement intégrés dans l'application de calendrier par défaut. Cela aide à rappeler l'événement aux supporters potentiels.</p><p>Le code QR de Google Maps peut même afficher l'emplacement de l'événement sur Google Maps afin que les participants n'aient pas de difficulté à trouver le lieu.</p>",
      },
    ],
  },
  {
    locale: "it",
    data: [
      {
        image: "/nonprofit/scan.png",
        tag: "Donazioni",
        title: "Promuovi la pagina di donazione della tua organizzazione",
        content:
          "Un'organizzazione non-profit può inserire un codice QR su una scatola di donazioni, su un poster, sulla porta di un caffè amichevole o al momento del pagamento per invitare le persone a contribuire a una campagna.",
      },
      {
        image: "/nonprofit/social.png",
        tag: "Social Media",
        title: "Organizzazioni non-profit sui social media",
        content:
          "<p>Il potere dei social media può essere difficile da esprimere a parole, ma è una parte integrante della strategia di raccolta fondi per un'organizzazione non-profit moderna.</p><p>Una presenza di successo sui social media non solo può aiutarti a espandere il tuo raggio d'azione e a rafforzare la tua comunità di sostenitori, ma è anche direttamente correlata all'ammontare raccolto.</p>",
      },

      {
        image: "/nonprofit/feedback.png",
        tag: "Rafforzare",
        title: "Migliorare la qualità dell'organizzazione",
        content:
          "<p>La soddisfazione e la fiducia delle persone sono ciò che rende un'organizzazione non-profit di successo. Incorporando il codice QR dei feedback di QRGateway, è possibile richiedere rapidamente i commenti dei partecipanti.</p><p>Inviaremo le recensioni per e-mail alla tua organizzazione. Ora puoi modificare e migliorare rapidamente i dipendenti, i volontari e i membri della tua organizzazione.</p>",
      },
      {
        image: "/nonprofit/donate.png",
        tag: "Evento",
        title: "Annuncio dell'evento dell'organizzazione",
        content:
          "<p>Qualsiasi organizzazione non-profit può utilizzare i codici QR degli eventi per condividere dettagli sugli eventi, posizioni o anche promemoria degli eventi.</p><p>In materiali promozionali per un evento imminente, un'organizzazione non-profit può aggiungere un codice QR non-profit che richiede a uno smartphone di eseguire la scansione per salvare i dettagli dell'evento incorporati nell'app calendario predefinita. Questo aiuta a ricordare l'evento ai potenziali sostenitori.</p><p>Il codice QR di Google Maps può persino mostrare la posizione dell'evento su Google Maps in modo che i partecipanti non abbiano difficoltà a trovare il luogo.</p>",
      },
    ],
  },
  {
    locale: "nl",
    data: [
      {
        image: "/nonprofit/scan.png",
        tag: "Donaties",
        title: "Promoot de donatiepagina van uw organisatie",
        content:
          "Een non-profitorganisatie kan een QR-code op een donatiebox plaatsen, op een poster, op de deur van een vriendelijke koffieshop of bij de kassa van een winkel om mensen uit te nodigen om bij te dragen aan een campagne.",
      },
      {
        image: "/nonprofit/social.png",
        tag: "Sociale media",
        title: "Non-profitorganisaties op sociale media",
        content:
          "<p>De kracht van sociale media kan moeilijk in woorden worden uitgedrukt, maar het is een integraal onderdeel van de fondsenwervingsstrategie voor een moderne non-profitorganisatie.</p><p>Een succesvolle aanwezigheid op sociale media kan u niet alleen helpen uw bereik te vergroten en uw gemeenschap van supporters te versterken, maar het heeft zelfs een directe correlatie met het opgehaalde bedrag.</p>",
      },

      {
        image: "/nonprofit/feedback.png",
        tag: "Versterken",
        title: "Verbeter de kwaliteit van de organisatie",
        content:
          "<p>Wat een non-profitorganisatie succesvol maakt, is de tevredenheid en het vertrouwen van haar mensen. Door de QRGateway-feedback QR-code op te nemen, kunt u snel feedback van deelnemers aanvragen.</p><p>We sturen recensies per e-mail naar uw organisatie. Nu kunt u snel uw medewerkers, vrijwilligers en leden van uw organisatie wijzigen en verbeteren.</p>",
      },
      {
        image: "/nonprofit/donate.png",
        tag: "Evenement",
        title: "Aankondiging van het evenement van de organisatie",
        content:
          "<p>Elke non-profitorganisatie kan evenementen-QR-codes gebruiken om evenementdetails, locaties of zelfs herinneringen aan evenementen te delen.</p><p>In promotionele materialen voor een aankomend evenement kan een non-profitorganisatie een Nonprofit-QR-code toevoegen die een smartphone nodig heeft om te scannen om evenementdetails in de standaardagenda-app op te slaan. Dit helpt om het evenement te herinneren aan potentiële supporters.</p><p>De Google Maps QR-code kan zelfs de locatie van het evenement op Google Maps weergeven, zodat deelnemers geen moeite hebben om de locatie te vinden.</p>",
      },
    ],
  },
  {
    locale: "ja",
    data: [
      {
        image: "/nonprofit/scan.png",
        tag: "寄付",
        title: "あなたの団体の寄付ページを宣伝する",
        content:
          "非営利団体は、寄付箱、ポスター、友好的なコーヒーショップのドア、または店舗のチェックアウトにQRコードを配置して、キャンペーンへの貢献を呼びかけることができます。",
      },
      {
        image: "/nonprofit/social.png",
        tag: "ソーシャルメディア",
        title: "非営利団体のソーシャルメディア",
        content:
          "<p>ソーシャルメディアの力は言葉に表現するのが難しいかもしれませんが、現代の非営利団体の資金調達戦略の重要な部分です。</p><p>成功したソーシャルメディアの存在は、あなたの範囲を拡大し、支援者コミュニティを強化するだけでなく、調達された金額に直接的な相関関係があることさえあります。</p>",
      },

      {
        image: "/nonprofit/feedback.png",
        tag: "強化",
        title: "団体の質を向上させる",
        content:
          "<p>非営利団体が成功するのは、その人々の満足と信頼です。QRGatewayフィードバックQRコードを取り入れることで、参加者から素早くフィードバックをリクエストできます。</p><p>私たちは組織にレビューをメールで送信します。今では、あなたはすばやくあなたの組織の従業員、ボランティア、およびメンバーを修正して改善することができます。</p>",
      },
      {
        image: "/nonprofit/donate.png",
        tag: "イベント",
        title: "団体のイベント発表",
        content:
          "<p>どの非営利団体でも、イベントQRコードを使用してイベントの詳細、場所、またはイベントリマインダーを共有できます。</p><p>今後のイベントのプロモーション資料には、スマートフォンでスキャンする必要がある非営利QRコードを追加して、デフォルトのカレンダーアプリに埋め込まれたイベントの詳細を保存することができます。これにより、潜在的な支援者にイベントを思い出させるのに役立ちます GoogleマップQRコードは、参加者が会場を見つけるのに苦労しないように、Googleマップ上にイベントの場所を表示することができます。</p>",
      },
    ],
  },
  {
    locale: "pt",
    data: [
      {
        image: "/nonprofit/scan.png",
        tag: "Doações",
        title: "Promova a página de doações da sua organização",
        content:
          "Uma organização sem fins lucrativos pode colocar um código QR em uma caixa de doações, em um cartaz, na porta de uma cafeteria amigável ou no caixa da loja para convidar as pessoas a contribuir para uma campanha",
      },
      {
        image: "/nonprofit/social.png",
        tag: "Mídias Sociais",
        title: "Organizações sem fins lucrativos nas mídias sociais",
        content:
          "<p>O poder das mídias sociais pode ser desafiador de expressar em palavras, mas é uma parte integrante da estratégia de captação de recursos para uma organização sem fins lucrativos moderna.</p><p>Uma presença bem-sucedida nas mídias sociais não só pode ajudar a expandir sua base de seguidores e impulsionar sua comunidade de apoiadores - ela até tem uma correlação direta com a quantidade arrecadada.</p>",
      },

      {
        image: "/nonprofit/feedback.png",
        tag: "Fortalecimento",
        title: "Melhore a qualidade da organização",
        content:
          "<p>O que torna uma organização sem fins lucrativos bem-sucedida é a satisfação e a confiança de suas pessoas. Ao incorporar o Código QR de Feedback do QRGateway, você pode solicitar rapidamente o feedback dos participantes.</p><p>Nós enviaremos as avaliações por e-mail para sua organização. Agora, você pode modificar e melhorar rapidamente os funcionários, voluntários e membros da sua organização.</p>",
      },
      {
        image: "/nonprofit/donate.png",
        tag: "Evento",
        title: "Anúncio de evento da organização",
        content:
          "<p>Qualquer organização sem fins lucrativos pode usar códigos QR de eventos para compartilhar detalhes do evento, locais ou mesmo lembretes de evento.</p><p>Em materiais promocionais para um evento próximo, uma organização sem fins lucrativos pode adicionar um código QR que exige que um smartphone o escaneie para salvar os detalhes do evento incorporados no aplicativo de calendário padrão. Isso ajuda a lembrar o evento para potenciais apoiadores.</p><p>O Código QR do Google Maps pode até exibir a localização do evento no Google Maps para que os participantes não tenham dificuldade em localizar o local.</p>",
      },
    ],
  },
];
